
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/unstable/react-dnd",
      function () {
        return require("private-next-pages/unstable/react-dnd.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/unstable/react-dnd"])
      });
    }
  